import { createSlice } from "@reduxjs/toolkit";

const INITIAL_STATE = { loading: true };

const syncReducers = {
  setMenu: (state, { payload }) => {
    return { ...payload, isLoaded: true };
  },
};

const store = createSlice({
  name: "menu",
  initialState: INITIAL_STATE,
  reducers: syncReducers,
});

export const { setMenu } = store.actions;

export default store.reducer;
